export const ACCESS_TYPES = {
    MEDICAL_AUDIO: 'medical_audio',
};
